import { ISendMessagePayload } from '../../../actions/sendMessage';
import { TAppState } from '../../../types/appState';
import { TOutcomingStatus } from '../../../types/messages';
import { removeMessageFromChatMessages, insertMessageInChatMessages } from '../../../utils/messageUtils';

export function updateState(
  state: TAppState,
  { message, messageId, messagesMap }: ISendMessagePayload,
  status?: TOutcomingStatus,
) {
  const chatId = message.chatId;
  const chatMessages = removeMessageFromChatMessages(messageId, messagesMap, state.openedChats[chatId].chatMessages);

  return {
    ...state,
    openedChats: {
      ...state.openedChats,
      [chatId]: {
        ...state.openedChats[chatId],
        chatMessages: insertMessageInChatMessages(messagesMap, message, chatMessages, state.user.userId, status),
      },
    },
  };
}
